module.exports = __webpack_public_path__ + "static/media/9.7394e6b2.png";